import { render, staticRenderFns } from "./PlatformPaymentDetailDialog.vue?vue&type=template&id=03ae3850&scoped=true"
import script from "./PlatformPaymentDetailDialog.vue?vue&type=script&lang=js"
export * from "./PlatformPaymentDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./PlatformPaymentDetailDialog.vue?vue&type=style&index=0&id=03ae3850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ae3850",
  null
  
)

export default component.exports